import { createContext, useContext, useState, useEffect } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  });
  const [currentDepartment, setCurrentDepartmentState] = useState(() => localStorage.getItem('currentDepartment') || null);
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
    // Force department picker on every login
    localStorage.removeItem('currentDepartment');
    setCurrentDepartmentState(null);
    return data.user;
  };

  const setCurrentDepartment = (code) => {
    if (code) localStorage.setItem('currentDepartment', code);
    else localStorage.removeItem('currentDepartment');
    setCurrentDepartmentState(code);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('currentDepartment');
    setUser(null);
    setCurrentDepartmentState(null);
    window.location.href = '/login';
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && !user) {
      setLoading(true);
      api.get('/auth/me').then(({ data }) => { setUser(data); localStorage.setItem('user', JSON.stringify(data)); }).catch(() => {}).finally(() => setLoading(false));
    }
  }, []); // eslint-disable-line

  return <AuthCtx.Provider value={{ user, login, logout, loading, currentDepartment, setCurrentDepartment }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
